import { render, staticRenderFns } from "./CrossCampusCheck.vue?vue&type=template&id=86ae398c&scoped=true"
import script from "./CrossCampusCheck.vue?vue&type=script&lang=js"
export * from "./CrossCampusCheck.vue?vue&type=script&lang=js"
import style0 from "./CrossCampusCheck.vue?vue&type=style&index=0&id=86ae398c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae398c",
  null
  
)

export default component.exports